import { render, staticRenderFns } from "./EightHolterReport.vue?vue&type=template&id=4fa8dbbd&scoped=true"
import script from "./EightHolterReport.vue?vue&type=script&lang=js"
export * from "./EightHolterReport.vue?vue&type=script&lang=js"
import style0 from "./EightHolterReport.vue?vue&type=style&index=0&id=4fa8dbbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8dbbd",
  null
  
)

export default component.exports